export default {
    locale: {
        en: 'english',
        de: 'german'
    },
    language: {
        de: 'German',
        en: 'English'
    },
    title: {
        label: 'Title',
        ariaLabel: {
            de: 'German title',
            en: 'English title'
        }
    },
    description: {
        label: 'Description',
        ariaLabel: {
            de: 'German description',
            en: 'English description'
        }
    },
    label: {
        title: 'Title',
        description: 'Description'
    },
    error: {
        title: {
            required: 'Please enter a title',
            length: 'The title must not be longer than {cnt} characters'
        },
        description: {
            required: 'Please enter a description',
            length: 'The description must not be longer than {cnt} characters'
        }
    }
}
